import { type PaginationState } from '@tanstack/react-table'
import { useState } from 'react'

import StripeCardsContext from 'components/context/StripeCardsContext'
import { getGetBrokersMembersMemberIdStripeIssuingCardsQueryKey } from 'utils/web_api'

import StripeCardsTable from './StripeCardsTable'

type StripeCardsMembersViewProps = {
  memberId: string
}

const StripeCardsMembersView = ({
  memberId,
}: StripeCardsMembersViewProps) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 1,
    pageSize: 10,
  })

  return (
    <StripeCardsContext.Provider
      value={{
        getStripeCardsQueryKey:
          getGetBrokersMembersMemberIdStripeIssuingCardsQueryKey(memberId, {
            'page[number]': pagination.pageIndex,
            'page[size]': pagination.pageSize,
          }),
      }}
    >
      <div className='flex-col w-full h-full space-y-4 bg-white rounded-lg max-w-[2000px] mx-auto'>
        <div className='flex items-center justify-between w-full mb-4 gap-x-2'>
          <div className='heading-md'>Stripe Issuing Cards</div>
        </div>
        <StripeCardsTable
          memberId={memberId}
          pagination={pagination}
          setPagination={setPagination}
        />
      </div>
    </StripeCardsContext.Provider>
  )
}

export default StripeCardsMembersView
